import { Form } from '../core'

$.fn.RetailerForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.retailer-form', {
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 30,
      onSubmit: function() {
        $('.retailer-form').addClass('retailer-form--blocked')
      },
      onSuccess: function() {
        $('.retailer-form__container').fadeOut(250, function() {
          requestAnimationFrame(function() {
            $('.retailer-form__success').fadeIn(250)
            $('.retailer-form__container').remove()
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          $('.retailer-form').removeClass('retailer-form--blocked')
          $('.retailer-form .form-error--invisible').removeClass('form-error--invisible')
          $('.retailer-form .field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
